import React from 'react';

const SavedBudget = () => {
    return <div>Saved Budget</div>;
};

export default SavedBudget;